export default "__VITE_ASSET__C9iHcq0C__"